import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import { useSideNav as m } from "./useSideNav2.mjs";
import { FloatingExpandIconButton as c, Icon as p } from "./styles119.mjs";
import u from "./Transition.mjs";
const M = l(
  ({ onClick: d, className: a, inner: t = !1 }) => {
    const { isExpanded: n, canCollapse: s, sidebarRef: r, isMobile: i } = m();
    return /* @__PURE__ */ o(
      u,
      {
        nodeRef: r,
        in: t ? n : !n,
        mountOnEnter: !0,
        unmountOnExit: !0,
        addEndListener: (e) => {
          r.current?.addEventListener("transitionend", e, !1);
        },
        children: (e) => /* @__PURE__ */ o(
          c,
          {
            size: "extraSmall",
            color: "secondary",
            onClick: d,
            $canCollapse: s,
            $isMobile: i,
            $status: e,
            $isExpanded: n,
            className: a,
            $inner: t,
            children: /* @__PURE__ */ o(p, { $isMobile: i })
          }
        )
      }
    );
  }
);
export {
  M as ExpandButton
};
//# sourceMappingURL=index312.mjs.map
